import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { EditFlow } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const EditFlowPage: FC = () => {
  const { accessToChangeFlow } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToChangeFlow}>
      <CabinetTitlePage title={'Flows'} goBack={'/cabinet/facebook/flows'} />
      <EditFlow />
    </Guard>
  );
};

export default EditFlowPage;
